import React from 'react';

const Separator = () => {
    return <div className="separator"></div>;
};

Separator.propTypes = {};

export default Separator;
